import * as React from 'react'

import { cn } from '~/shadcn/lib/utils'

function Input({
  className,
  type,
  'aria-invalid': ariaInvalid,
  rightElement,
  ...props
}: React.ComponentProps<'input'> & { rightElement?: React.ReactNode }) {
  return (
    <div className={cn('relative')}>
      <input
        type={type}
        data-slot="input"
        autoComplete="off"
        aria-invalid={ariaInvalid}
        className={cn(
          'file:text-primary placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground',
          'min-w-0 border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none font-semibold',
          'file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium',
          'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 h-11 w-full',
          !ariaInvalid && 'border-focus hover:border-primary!',
          ariaInvalid && 'border-destructive',
          rightElement && 'pr-8',
          className
        )}
        {...props}
      />
      {rightElement && (
        <div className="absolute right-0 top-0 pr-3 bottom-0 flex items-center justify-center">
          {rightElement}
        </div>
      )}
    </div>
  )
}

export { Input }
